import { Col, Row } from "antd";
import React, { useState } from "react";
import {
  BsChatLeftTextFill,
  BsFillTelephoneFill,
  BsTelephone,
} from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import { IoLocationSharp, IoMailOutline } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";
import Modal from "../../../../components/modal/Modal";
import AboutUs from "./AboutUs/AboutUs";
import Documents from "./documents/Document";
import Services from "./services/Services";
import styles from "./subContact.module.css";
import {
  AntdTab,
  Box,
  ServiseProfileComponent,
  SubmitButton,
  TextComponent,
} from "../../../../components";
import RatingsAndReviews from "./ratings/Ratings";
import CopyLinkModal from "../../../../components/copyLinkModal/CopyLinkModal";
import PhoneNumberModal from "../../../../components/phoneNumberModal/PhoneNumberModal";
import { LocIcon } from "../../../../components/icons/Icons";
import addPerson from "../../../../assets/addPerson.svg";
import { useSelector } from "react-redux";
import { VendorMiddleware } from "../../../../Store/Middlewares/VendorMiddleware";

const items = [
  {
    key: "1",
    label: "About Us",
    children: (
      <>
        <Row className={styles.tabContentCont}>
          <AboutUs />
        </Row>
      </>
    ),
  },
  {
    key: "2",
    label: "Services",
    children: (
      <Row className={styles.tabContentCont}>
        <Services />
      </Row>
    ),
  },
  {
    key: "3",
    label: "Documents",
    children: (
      <Row className={styles.tabContentCont}>
        <Documents />
      </Row>
    ),
  },

  {
    key: "4",
    label: "Reviews & Ratings",
    children: (
      <Row className={styles.tabContentCont}>
        <RatingsAndReviews />
      </Row>
    ),
  },
];

const AddPersonIcon = () => {
  return <img src={addPerson} />;
};

const SubContacrDetails = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const EventID = useSelector((state) => state.EventReducer.EventDetails?.id);
  // const user = useSelector(state => state.AuthReducer.user);
  const Details = useSelector((state) => state.VendorReducer.VendorDetails);
  const {
    state: { data: userData },
  } = useLocation();
  const navigate = useNavigate();
  console.log("EventID", EventID);
  console.log("Details", Details);
  const onChange = (key) => {
    console.log(key);
  };
  const { state } = useLocation();
  // useEffect(() => {
  //   getData();
  // }, []);

  // const getData = () => {
  //   setloader(true);
  //   let data = {
  //     vendor_id: userData?.id,
  //     event_id: EventID,
  //   };
  //   dispatch(VendorMiddleware.getDetails(data))
  //     .then((res) => {
  //       // setDetails(res);
  //       setloader(false);
  //     })
  //     .catch(() => {
  //       setloader(false);
  //     });
  // };
  return (
    <>
      <ServiseProfileComponent image={userData?.img}>
        <Col>
          <Row className={styles.contentCont}>
            <Col>
              <Row>
                <TextComponent text={userData?.title} textClass={styles.name} />
              </Row>
              <Row>
                <TextComponent text={"Photographer"} textClass={styles.type} />
              </Row>
            </Col>
            <Col className={styles.iconsCont}>
              <Box
                boxClass={styles.iconBox}
                onClick={() => {
                  navigate("/inbox");
                }}
              >
                <BsChatLeftTextFill size={17} className={styles.icon} />
              </Box>
              <Box
                boxClass={styles.iconBox}
                onClick={() => {
                  setIsModalOpen(true);
                }}
              >
                <BsFillTelephoneFill size={17} className={styles.icon} />
              </Box>
            </Col>
          </Row>
          <Row
            style={{ justifyContent: "space-between", alignItems: "flex-end" }}
          >
            <Col>
              <Row className={styles.locCont}>
                <BsTelephone className={styles.locIcon} size={20} />
                <TextComponent
                  text={"Contact :"}
                  textClass={styles.DetailHead}
                />
                <TextComponent
                  text={"+1 (234) 456-4567"}
                  textClass={styles.locText}
                />
              </Row>
              <Row className={styles.locCont}>
                <IoMailOutline className={styles.locIcon} size={20} />
                <TextComponent text={"Email :"} textClass={styles.DetailHead} />
                <TextComponent
                  text={"trishjames@gmail.com"}
                  textClass={styles.locText}
                />
              </Row>
              <Row className={styles.locCont}>
                <LocIcon size={20} />
                <TextComponent
                  text={"Address :"}
                  textClass={styles.DetailHead}
                />
                <TextComponent
                  text={"456 Oak Avenue New York, NY 10001 " + "1Km"}
                  textClass={styles.locText}
                />
                {/* <TextComponent text={"1Km"} textClass={styles.locText} /> */}
              </Row>
            </Col>
            {state?.eventData && (
              <Col className={styles.hireBtn}>
                <SubmitButton
                  title="Add To Vendors"
                  rightIcon={<AddPersonIcon />}
                  btnClass={styles.addVendorBtn}
                />
              </Col>
            )}
          </Row>
        </Col>
      </ServiseProfileComponent>
      <AntdTab items={items} />
      <PhoneNumberModal
        isPhoneModalOpen={isModalOpen}
        setIsPhoneModalOpen={setIsModalOpen}
        phoneNumber="+1 (234) 456-4567"
      />
    </>
  );
};

export default SubContacrDetails;
